'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 'medium' : _ref$size,
      _ref$display = _ref.display,
      display = _ref$display === undefined ? '' : _ref$display,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'dark' : _ref$type,
      _ref$isModal = _ref.isModal,
      isModal = _ref$isModal === undefined ? false : _ref$isModal;
  return _react2.default.createElement('span', { className: (0, _classnames2.default)(_styles2.default.loadingSpinner, _styles2.default[size], _styles2.default[display], _styles2.default[type], _defineProperty({}, _styles2.default.isModal, isModal)) });
};